import { ColumnEditorOptions } from "primereact/column";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { QuestionOption } from "../../../types/checklist";

interface SingleChoiceEditorProps {
    options: ColumnEditorOptions;
    questionOptions: QuestionOption[];
}

export const SingleChoiceEditor = ({ options, questionOptions }: SingleChoiceEditorProps) => {
    const handleChange = (e: DropdownChangeEvent) => {
        if (options.editorCallback) {
            options.editorCallback(e.value);
        }
    };

    const dropdownOptions = questionOptions.map((opt) => ({
        label: opt.text,
        value: opt.id,
    }));

    return (
        <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={handleChange}
            placeholder="Select an option"
            className="w-full"
            autoFocus
        />
    );
};

export const singleChoiceDisplayTemplate = (value: unknown, questionOptions?: QuestionOption[]): string => {
    if (!value) return "";
    if (!questionOptions) return String(value);

    const option = questionOptions.find((opt) => opt.id === value);
    return option?.text ?? String(value);
};
